import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { asyncThunkWrapper } from "../handleAsyncThunk"
import { BASEURI, headers } from "../../utils/helper"

// --------------- Handle create new chat ---------------
export const handleCreateNewChat = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {

    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/admin/chat/get`,
      },
      thunkAPI,
      { showToast: false }
    )
  }
)

const initialState = {
  chat: {},
  socket: null,
}
const socket = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setSocket: (state, { payload }) => {
      state.socket = payload
    },
    setCurrectChat: (state, { payload }) => {
      state.chat = payload
    },
  }
})

export const {
  setSocket,
  setCurrectChat,
} = socket.actions
export default socket.reducer